import { sendServerMessage } from "./serverMessaging";

const commandNames = {
  START_KIOSK: "StartKiosk",
  START_MULTIPLE_KIOSKS: "StartMultipleKiosks",
  START_ALL_KIOSKS: "StartAllKiosks",
  PAUSE_KIOSK: "PauseKiosk",
  PAUSE_MULTIPLE_KIOSKS: "PauseMultipleKiosks",
  PAUSE_ALL_KIOSKS: "PauseAllKiosks",
};

export const startKiosk = kiosk => {
  const message = {
    type: commandNames.START_KIOSK,
    ...kiosk,
  };

  return sendServerMessage(message);
};

export const startMultipleKiosks = kiosks => {
  const message = {
    type: commandNames.START_MULTIPLE_KIOSKS,
    ...kiosks,
  };
  return sendServerMessage(message);
};

export const pauseKiosk = kiosk => {
  const message = {
    type: commandNames.PAUSE_KIOSK,
    ...kiosk,
  };

  return sendServerMessage(message);
};

export const pauseMultipleKiosks = kiosks => {
  const message = {
    type: commandNames.PAUSE_MULTIPLE_KIOSKS,
    ...kiosks,
  };
  return sendServerMessage(message);
};

export const startAllKiosks = stationid => {
  const message = {
    type: commandNames.START_ALL_KIOSKS,
    stationid,
  };

  return sendServerMessage(message);
};

export const pauseAllKiosks = stationid => {
  const message = {
    type: commandNames.PAUSE_ALL_KIOSKS,
    stationid,
  };

  return sendServerMessage(message);
};



// WEBPACK FOOTER //
// ./src/lib/serverCommands.js